import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9k4junmbp: FaireProductEntity = {
  token: "p_m9k4junmbp",
  type: "product",
  name: "Level3 2 IN 1 Shampoo and Conditioner, 33.8 oz",
  brandToken: "b_7mrrycec9d",
  brandName: "KT Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/14c31b46b90bba33e11d09f9bfc21507f462b45c80bf9370ad4a6830a9b80ff2.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.73,
  description:
    "Health & Beauty > Hair > Shampoo & Conditioner.Brand : Level3.Level3 2 IN 1 Shampoo and Conditioner, 33.8 oz.Save time and money while maintaining great hair with our combined shampoo and conditioner. Washing hair can be time-consuming, especially when you're pressed for time in a busy barbershop or at home. Our 2-in-1 formula, enriched with keratin, efficiently cleans and conditions hair in one step, leaving it smooth, shiny, and manageable. With two high-quality products in one large bottle, it’s also a cost-effective choice.Convenient formula for washing and conditioning hair in one step.Infused with keratin for smoother, frizz-free hair with a polished finish.Cleanses, conditions, and revitalizes all hair types, enhancing shine.Practical size for barbershops and a budget-friendly option for home use.",
  tags: [],
  msrpDollars: 17.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:14.215Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
